<template>
  <BaseInput
    id="daily"
    :label="getComponentUiText('app-scanning-schedule-modal-filed-recurring-1')"
    :class-name="'tw-mt-[0px]'"
    :validation="
      formModel.value === optionDailySelected.every
        ? validation.interval
        : validation.value
    "
    :col-title="4"
    :col-input="8"
  >
    <div class="dropdown tw-flex tw-flex-col tw-gap-y-[30px]">
      <div
        class="tw-w-full tw-flex tw-items-center tw-justify-between tw-flex-wrap tw-gap-[20px]"
      >
        <div class="tw-flex">
          <BaseCheckbox
            :text="
              getComponentUiText('app-scanning-schedule-modal-filed-every-1')
            "
            :text-style="'!tw-text-[13px] !tw-font-[400] !tw-leading-normal !tw-text-[#231F20] tw-ml-[2px]'"
            color="#387DFF"
            :ticked="formModel.value === optionDailySelected.every"
            :disabled="!disabled ? '' : answer"
            @selected="() => handleState(optionDailySelected.every)"
            @unselected="() => handleState(optionDailySelected.unselected)"
          />
        </div>
        <div class="tw-min-w-[420px] tw-flex tw-items-center tw-gap-[20px]">
          <div class="tw-min-w-[100px]">
            <BaseInput
              id="count"
              v-model="formModel.interval"
              type="number"
              :placeholder="
                getComponentUiText(
                  'app-scanning-schedule-modal-input-placeholder-1',
                )
              "
              :input-class="'tw-w-[150px]'"
              :class-name="'!tw-mt-0'"
              :disabled="formModel.value !== optionDailySelected.every"
              :validation="validation.interval"
              @update:model-value="(val) => (formModel.interval = val)"
              @blur="blurCount"
              @keydown="preventNonNumeric"
            >
              <template #feedback>
                <div />
              </template>
            </BaseInput>
          </div>
          <div
            class="tw-text-[13px] tw-font-[400] tw-text-[#231F20] tw-leading-normal"
          >
            {{
              getComponentUiText("app-scanning-schedule-modal-filed-day(s)-1")
            }}
          </div>
        </div>
      </div>
      <div class="tw-flex">
        <BaseCheckbox
          :text="
            getComponentUiText(
              'app-scanning-schedule-modal-filed-every-weekday-1',
            )
          "
          :text-style="'tw-text-[13px] !tw-font-[400] tw-ml-[2px]'"
          color="#387DFF"
          :ticked="formModel.value === optionDailySelected.everyWeek"
          :disabled="!disabled ? '' : answer"
          @selected="() => handleState(optionDailySelected.everyWeek)"
          @unselected="() => handleState(optionDailySelected.unselected)"
        />
      </div>
    </div>
  </BaseInput>
</template>

<script setup>
import { ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import BaseInput from "../common/form/baseInput.vue";
import BaseDropDown from "../common/form/baseDropDown.vue";
import BaseCheckbox from "../common/form/baseCheckbox.vue";
import { optionDay } from "@/utils/utilities";
import { optionDailySelected } from "@/utils/constants";

const props = defineProps({
  modelValue: { type: Object, required: true },
  /** Vue Validation object */
  validation: {
    type: Object,
    default: () => ({}),
  },
});
const emit = defineEmits([
  "onUpdate",
  "update:value",
  "update:answer",
  "update:modelValue",
]);

const formModel = ref(props.modelValue);

watch(
  formModel,
  (newVal) => {
    emit("update:modelValue", newVal);
  },
  { deep: true },
);

const handleState = (value) => {
  // state.value = value;
  formModel.value.value = value;
  emit("onUpdate", value);
  emit("update:answer", value);
};

const blurCount = () => {
  const val = formModel.value.interval;
  if (val) {
    const temp = Math.max(1, Math.min(50, val));
    formModel.value.interval = temp;
  }
};

const preventNonNumeric = (evt) => {
  if (evt.key.length === 1 && !/[0-9]/.test(evt.key)) {
    evt.preventDefault();
  }
};
</script>
